<template>
  <section>
    <h6 class="q-mb-md">Company Representative:</h6>

    <div class="bg-gray q-pr-md q-pb-md q-ml-none row q-col-gutter-md">
      <div class="col-12 col-sm-6">
        <q-input
          v-model="transporterSync.repFirstName"
          label="First Name"
          error-message="Representative first name is required"
          no-error-icon
          :error="getErrorState(v.transporter.repFirstName)"
        />
      </div>

      <div class="col-12 col-sm-6">
        <q-input
          v-model="transporterSync.repLastName"
          label="Last Name"
          error-message="Representative last name is required"
          no-error-icon
          :error="getErrorState(v.transporter.repLastName)"
        />
      </div>

      <div class="col-12 col-sm-6">
        <q-input
          v-model="transporterSync.repPhone"
          label="Tel Number"
          no-error-icon
          bottom-slots
          :error="getErrorState(v.transporter.repPhone)"
        >
          <template #error>
            <span v-if="!v.transporter.repPhone.required"> Representative phone is required </span>
            <span v-else-if="!v.transporter.repPhone.numeric">
              Representative phone must only contain numeric characters
            </span>
          </template>
        </q-input>
      </div>

      <div class="col-12 col-sm-6">
        <q-select
          v-model="transporterSync.repPosition"
          label="Position"
          option-value="v"
          option-label="k"
          emit-value
          map-options
          :options="repPositions"
        />
      </div>
    </div>
  </section>
</template>

<script>
import getErrorState from '@/utils/mixins/getErrorState';

export default {
  mixins: [getErrorState],
  props: {
    transporter: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      repPositions: [
        { k: 'Owner', v: 'owner' },
        { k: 'Director', v: 'director' },
        { k: 'Sales Manager', v: 'salesManager' },
        { k: 'Sales Representative', v: 'representative' },
        { k: 'Transport Coordinator', v: 'coordinator' },
        { k: 'Operations Manager', v: 'operationsManager' },
        { k: 'Administration', v: 'administration' },
      ],
    };
  },

  computed: {
    transporterSync: {
      get() {
        return this.transporter;
      },

      set(val) {
        this.$emit('update:transporter', val);
      },
    },
  },
};
</script>

<style></style>
